import { CCard, CCardBody, CCardHeader } from "@coreui/react";
import TaxPayerEmailSettingsForm from "../components/tax-payer/TaxPayerEmailSettingsForm";
import TaxPayerWhatsappSettingsForm from "../components/tax-payer/TaxPayerWhatsappSettingsForm";
import { useNotificationSettingsAccess } from "../hooks/notification-settings-access";
import PermissionRequired from "../components/permissions/PermissionRequired";
import Loading from "../components/indicators/Loading";

const TaxPayerNotificationSettingsPage = ({
  channel,
}: {
  channel: "email" | "whatsapp";
}) => {
  const { taxPayer, ready, allowed, whatsappAllowed } =
    useNotificationSettingsAccess();
  if (!ready) return <Loading height="30vh" />;
  if (!allowed || (channel === "whatsapp" && !whatsappAllowed))
    return <PermissionRequired />;
  return (
    <CCard>
      <CCardHeader>
        <h3 className="mb-0">
          {channel === "email"
            ? "Configuración de correo"
            : "Configuración de WhatsApp"}
        </h3>
      </CCardHeader>
      <CCardBody>
        {channel === "email" ? (
          <TaxPayerEmailSettingsForm key={taxPayer.id} taxPayer={taxPayer} />
        ) : (
          <TaxPayerWhatsappSettingsForm key={taxPayer.id} taxPayer={taxPayer} />
        )}
      </CCardBody>
    </CCard>
  );
};

export const TaxPayerEmailSettingsPage = () => (
  <TaxPayerNotificationSettingsPage channel="email" />
);
export const TaxPayerWhatsappSettingsPage = () => (
  <TaxPayerNotificationSettingsPage channel="whatsapp" />
);
